<template>
  <v-app>
    <PasswordChangeDialog ref="changePassword" />
    <CreateProfileDialog ref="createProfile" />

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-navigation-drawer v-model="drawer" v-if="user" app>
      <v-list>
        <v-list-item two-line v-on="on">
          <v-list-item-avatar>
            <v-icon style="font-size:46px">account_circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ user.user.email }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link v-for="app in apps" :to="app.link" :key="app.name">
          <v-list-item-icon>
            <v-icon>{{ app.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ app.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list>
          <v-divider></v-divider>
          <v-list-item @click="changePassword">
            <v-list-item-icon>
              <v-icon>lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Password</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="signout">
            <v-list-item-icon>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Sign out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar app elevation="1" v-if="user">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <div style="display:inline-block; float:left" class="mr-4">
          <img :src="assetRoot + '/Logo.jpg'" style="width:32px;">
        </div>
        <span>{{ title }}</span>
        <span class="ml-4" style="font-size:.9em" v-if="pageTitle">&gt; {{ pageTitle }}</span>
      </v-toolbar-title>
      <v-spacer />
      <a href="https://taxteam.co.nz/help" target="_blank">
        HELP <v-icon small>mdi-help</v-icon>
      </a>
      <!--
      <v-badge color="red" :content="notification" :value="messages" overlap>
        <v-icon>notifications_none</v-icon>
      </v-badge>
      -->
    </v-app-bar>

    <v-footer app class="font-weight-medium">
      <v-col class="text-center" cols="12">
        &copy; Copyright {{ new Date().getFullYear() }} — {{ companyName }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class'
import PasswordChangeDialog from '@/components/dialog/PasswordChangeDialog'
import CreateProfileDialog from '@/components/dialog/CreateProfileDialog'
import UserService from '@/services/UserService.js'

const ProfileModule = namespace('profile')

@Component({
  components: {
    PasswordChangeDialog,
    CreateProfileDialog
  }
})
export default class App extends Vue {
  drawer = false
  email = null
  messages = 0
  notification = ''

  @Getter user
  @Getter apps
  @Getter title
  @Getter pageTitle
  @Getter companyName
  @Getter assetRoot
  @Action setUser
  @Action setVerified
  @ProfileModule.Action updateFromAPI
  @ProfileModule.Getter('fields') profileItems

  beforeCreate () {
    this.drawer = this.$vuetify.breakpoint.mdAndUp
    if (!this.user && this.$route.path.match(/^\/reset\//) === null) {
      UserService.check()
        .then(resp => {
          this.setUser({
            user: resp.data
          })
          this.email = this.user.user.email
          this.getProfile()
        })
        .catch(err => {
          console.error(err.response)
          this.$router.replace({ name: 'auth' })
        })
    }
  }

  mounted () {
    this.notification = this.messages > 9 ? '9+' : String(this.messages)
  }

  getProfile () {
    this.updateFromAPI(null)
      .catch(err => {
        console.error('error', err)
        const resp = err.response
        if (resp.status === 404 && resp.data.detail === 'No profile yet') {
          location.href = '/profile'
          // this.$refs.createProfile.open()
          // console.warn(err.response.data)
          // this.$router.push('profile')
        }
      })
      .finally(() => {
        try {
          this.setVerified(this.profileItems[2].value)
        } catch (e) {
        }
      })
  }

  signout () {
    UserService.signout()
      .then(resp => {
        this.setUser(null)
      })
      .catch(err => {
        console.error('signout', err)
        this.setUser(null)
      })
      .finally(() => {
        location.reload()
      })
    // setTimeout(() => {
    //   this.$router.replace({ name: 'auth' })
    // }, 100)
  }

  changePassword () {
    this.$refs.changePassword.open()
  }
}
</script>
